import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
  selector: 'app-markbar-help',
  templateUrl: './markbar-help.component.html',
  styleUrls: ['./markbar-help.component.scss']
})
export class MarkBarHelpComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<MarkBarHelpComponent>,
    public matDialog: MatDialog) { }


 /* closeModal() {
    this.dialogRef.close();
  }*/

  ngOnInit(): void {
  }

}
